import { ButtonProps } from '@msc-b2c/interfaces/types';
import { Icon } from '../icons/Icon';
import classNames from 'classnames';

import './button.module.scss';
import { handleKeyDown } from '@msc-b2c/shared-utils/keyboardUtils';

export const Button = ({
  id,
  buttonType = 'button',
  text,
  icon,
  iconAriaLabel = '',
  disabled,
  accessibilityLabel,
  styleOption = '',
  buttonLink,
  buttonTarget,
  tooltipText,
  ariaHidden,
  onClick,
}: ButtonProps) => {
  return text || icon ? (
    <div
      id={id}
      className={classNames(styleOption, { '-icon-only': icon && !text })}
    >
      {buttonLink?.url ? (
        <a
          className={classNames('cmp-button', { disabled: disabled })}
          href={disabled ? undefined : buttonLink?.url}
          onClick={onClick}
          onKeyDown={onClick ? (event) => handleKeyDown(event, onClick) : undefined}
          aria-label={accessibilityLabel}
          aria-disabled={disabled}
          tabIndex={disabled || ariaHidden ? -1 : 0}
          role="button"
          target={buttonTarget ?? '_self'}
          aria-hidden={ariaHidden ?? false}
        >
          {icon && (
            <Icon
              icon={icon}
              tooltipTitle={accessibilityLabel}
            />
          )}
          <span>{text}</span>
        </a>
      ) : (
        <button
          type={buttonType}
          className={'cmp-button'}
          aria-label={accessibilityLabel}
          disabled={disabled}
          onClick={onClick}
          onKeyDown={onClick ? (event) => handleKeyDown(event, onClick) : undefined}
          aria-disabled={disabled}
          tabIndex={disabled || ariaHidden ? -1 : 0}
          aria-hidden={ariaHidden ?? false}
        >
          {icon && (
            <Icon
              icon={icon}
              ariaLabel={iconAriaLabel}
              tooltipTitle={tooltipText}
            />
          )}
          {text && <span>{text}</span>}
        </button>
      )}
    </div>
  ) : null;
};
